module.exports = __webpack_public_path__ + "img/title_rgm1.df3ba9e0.png";